import { inject, Injectable } from '@angular/core';
import {
  BasicDialogService,
  DialogPresets,
} from '@principle-theorem/ng-shared';
import {
  type IPractice,
  isPractice,
} from '@principle-theorem/principle-core/interfaces';
import { isWithRef, snapshot } from '@principle-theorem/shared';
import { ManagementResource } from '../models/management-resource';
import {
  type IManagementTool,
  type IToolRunContext,
} from '../models/management-tool';
import {
  type IOvieHealthDialogData,
  OvieHealthDialogComponent,
} from '../ovie-health-dialog/ovie-health-dialog.component';

@Injectable({ providedIn: 'root' })
export class OvieHealthDataTool implements IManagementTool {
  private _dialog = inject(BasicDialogService);

  readonly name = 'ovie-health-data';
  readonly label = 'Ovie Health';
  readonly icon = 'menu_book';
  readonly description = `Manage this practice's AI Receptionist settings and view its live Ovie Health data`;
  readonly resource = ManagementResource.Practice;

  async run(context: IToolRunContext): Promise<void> {
    if (!context.resource) {
      return;
    }
    const value = await snapshot(context.resource.value$);
    if (!value || !(isPractice(value) && isWithRef<IPractice>(value))) {
      return;
    }
    const data: IOvieHealthDialogData = { practice: value };
    this._dialog.open(OvieHealthDialogComponent, DialogPresets.large({ data }));
  }
}
